<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Overdue Malaria Adverse Events
      </h2>
      <p class="tw-italic tw-text-gray-700">
        A table of malaria cases that have not been treated after 7 days since diagnosis.
      </p>
    </b-container>

    <b-container fluid>
      <b-row>
      <b-col lg="4"></b-col>
      <b-col lg="4"></b-col>
      <b-col lg="4">
        <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <br />
      </b-col>
    </b-row>
    </b-container>

    <hr>
    
    <b-card no-body>
        <b-tabs card fill>
          <b-tab :title="'TREATMENT OVERDUE'" active>
            <b-card-text >
              <b-table striped hover :fields="fields" :items="items" :filter="filter" :tbody-tr-class="'clickable'" @row-clicked="rowClicked">

              </b-table>
            </b-card-text>
          </b-tab>
        </b-tabs>
    </b-card>
    
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "subject_id", label: "Subject ID" },
        { key: "ae_sae_id", label: "Malaria AE/SAE ID" },
        { key: "date_of_collection", label: "Bloodslide Collected Date" },
        { key: "ae_sae_date", label: "Malaria Diagnosis Date" },
      ],
      items: [],
      componentKey: 0,
      filter: null,
      active_aesae_list: [],
      active_aesae_modal_title: 'AE/SAE Cases',
      selected_subject: null
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/treatment-overdue/get_list").then(response => {
      that.items = response.data.items;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('subjectsreferred', 
            ['getSubjectsReferredCount', 'setSubjectsReferredCount']),

    refreshSideNavCount(){
      this.getSubjectsReferredCount().then((response) => {
                this.setSubjectsReferredCount(response.data);
            })
    },
    view_aesae_list: function(index){
      let that = this;
      that.active_aesae_list = that.subjects[index].aesae_list;
      that.active_aesae_modal_title = 'AE/SAE Cases for ' + that.subjects[index].subject_id;
    },

     rowClicked(record, index){
      let that = this;
      that.selected_subject = record;
    },

    showModal() {
        this.$refs[('contact_info_modal')].show();
      },
    dismiss: function(index){
      let that = this;
      HTTP.post("/kenya/subjects_referred/"+that.subjects[index].id+"/", {
        status: 'dismiss'
      }).then(() => {
          var dismissed_obj = that.subjects.splice(index, 1)[0];
          that.dismissed_subjects.push(dismissed_obj);
          that.refreshSideNavCount();
      });


    }
  }
};
</script>

<style>
.right-text{
  text-align: right;
}
.clickable {
  cursor: pointer;
}
</style>